import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, ViewChild, AfterViewInit, EventEmitter} from '@angular/core';
import { Product} from '../products/product';
import { SwiperDirective } from 'ngx-swiper-wrapper';
import { Configuration } from '../configuration';

@Component({
  selector: "app-product-carousel",
  templateUrl: "./product-carousel.component.html",
  styleUrls: ["./product-carousel.component.scss"]
})
export class ProductCarouselComponent
  implements OnInit, OnChanges, AfterViewInit {
  carousel = false;
  config = {
    init: true,
    slidesPerView: "auto",
    spaceBetween: 20,
    observer: true,
    autoHeight: false,
    navigation: {
      nextEl: ".app-swiper-button-next",
      prevEl: ".app-swiper-button-prev"
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets"
    }
  };
  index = 0;
  swiperInstance: any;

  // swiperWidth: number = 0;

  @Input()
  items: Product[];

  @Input()
  title: string;

  @Input()
  configurationInput: Configuration;

  @Output()
  indexChange = new EventEmitter();

  @ViewChild("swiperWrapper")
  public swiperWrapper: any;

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.swiperInstance = this.swiperWrapper.nativeElement.swiper;

    setTimeout(() => {
      this.swiperInstance.update();
      // this.swiperInstance.slideTo(0, 0);
      this.swiperInstance.updateSize();
    }, 1000);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.items) {
      this.items = changes.items.currentValue;
      // if (this.swiperInstance) {
      //   this.swiperInstance.update();
      //   this.swiperInstance.slideTo(0, 0);
      //   this.swiperInstance.updateSize();
      // }
    }
  }

  indexChangeHandler(index) {
    // console.log("index", index);
    this.indexChange.emit(index);
  }
}



// WEBPACK FOOTER //
// ./src/app/product-carousel/product-carousel.component.ts


// WEBPACK FOOTER //
// ./src/app/product-carousel/product-carousel.component.ts